// import { useState } from "react";
// import ReactImageZoom from "react-image-zoom";

// import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
// import InnerImageZoom from 'react-inner-image-zoom';

function SingleImage({ src }) {
//   const [backgroundPosition, setBackgroundPosition] = useState("0% 0%");

//   const handleMouseMove = (e) => {
//     const { left, top, width, height } = e.target.getBoundingClientRect();
//     const x = ((e.pageX - left) / width) * 100;
//     const y = ((e.pageY - top) / height) * 100;
//     setBackgroundPosition(`${x}% ${y}%`);
//   };

//   let style = {
//     backgroundImage: image.src,
//     backgroundPosition: backgroundPosition,
//   };

  return (
    // <figure onMouseMove={handleMouseMove} style={style}>
    //   <img src={image.src} alt="" className="img-fluid image_zoom_cls-0" />
    // </figure>
    <img src={src} alt="" className="img-fluid image_zoom_cls-0" />
    // <ReactImageZoom zoomWidth={500} width={400} height={250} zoomPosition='original' img={image.src} />

    // <InnerImageZoom src={image.src} zoomScale={0.9} zoomSrc={image.src}/>
  );
}

export default SingleImage;
